import { Header } from '@/components/Header';
import { LoadingSpinner } from '@/components/LoadingSpinner';

import { useAuth } from '@/hooks/useAuth';

import { Profile } from '@/pages/Profile';

function ProfileLayout() {
  const { user, signOut, loading } = useAuth();

  if (loading || !user) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <LoadingSpinner message="Loading profile..." />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header user={user} onSignOut={signOut} />
      <Profile />
    </div>
  );
}

export default ProfileLayout;
